// extracted by mini-css-extract-plugin
export default {"container":"mobile-navigation_container__+12Ne","groupTwo":"mobile-navigation_groupTwo__U5teR"};